import { initializePaddle } from '@paddle/paddle-js';

let paddleInstance;
let paddleInitialization;

/** Initialize Paddle's localized, provider-formatted price preview adapter. */
export async function initializeLocalizedPricing({
  clientToken,
  environment,
  priceIds,
  eventCallback,
  onReady,
}) {
  if (!clientToken || !priceIds || typeof priceIds !== 'object') return undefined;

  if (!paddleInitialization) {
    paddleInitialization = initializePaddle({
      token: clientToken,
      environment: environment === 'production' ? 'production' : 'sandbox',
    });
  }
  let paddle;
  try {
    paddle = paddleInstance || await paddleInitialization;
  } catch (error) {
    paddleInitialization = undefined;
    throw error;
  }
  if (!paddle) return undefined;
  paddleInstance = paddle;
  if (eventCallback) paddle.Update({ eventCallback });

  const previewLocalizedMonthlyPrice = async (planKey) => {
    const priceId = priceIds[planKey];
    if (!priceId) throw new TypeError('No active Paddle price for this plan');
    const response = await paddle.PricePreview({
      items: [{ priceId, quantity: 1 }],
    });
    const formattedPrice = response.data.details.lineItems[0]?.formattedTotals?.total;
    if (typeof formattedPrice !== 'string' || !formattedPrice) {
      throw new TypeError('Paddle did not return a localized monthly price');
    }
    return formattedPrice;
  };

  const integration = { paddle, previewLocalizedMonthlyPrice };
  onReady?.(integration);
  return integration;
}
